import { OverlayTrigger, Popover, PopoverBody } from "react-bootstrap";
import SolarIcon from 'components/icons/SolarIcon';

const EOverlay = ({ text, iconClass = 'info-circle' }) => {
    const icon = (
        <span className="d-inline-flex align-items-center">
            <SolarIcon name={iconClass} className={text ? 'text-info' : 'text-muted'} />
        </span>
    );

    if (!text) return icon;

    return (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="left"
            delay={{ show: 80, hide: 120 }}
            container={typeof document !== 'undefined' ? document.body : undefined}
            overlay={
                <Popover className="popover-sm">
                    <PopoverBody>
                        <span dangerouslySetInnerHTML={{ __html: String(text).replaceAll('\n', '<BR>') }}></span>
                    </PopoverBody>
                </Popover>
            }
        >
            {icon}
        </OverlayTrigger>
    );
};

export default EOverlay;
